module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "italics",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("\n    Written RoundTable Trends\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.online_loading),
      expression: "online_loading"
    }],
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('span', {
    staticClass: "pl-caption"
  }, [_vm._v("loading")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-cog fa-spin fa-fw"
  })]), _vm._v(" "), _c('trending-online-roundtables', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.online_loading),
      expression: "!online_loading"
    }],
    attrs: {
      "onlineTrendingData": _vm.online_trending_data
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "italics",
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("\n    Verbal RoundTable Trends\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.live_loading),
      expression: "live_loading"
    }],
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('span', {
    staticClass: "pl-caption"
  }, [_vm._v("loading")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-cog fa-spin fa-fw"
  })]), _vm._v(" "), _c('trending-live-discussions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.live_loading),
      expression: "!live_loading"
    }],
    attrs: {
      "liveTrendingData": _vm.live_trending_data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5c17f374!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/studentActivitySummary/components/trendingCharts.vue
// module id = 1703
// module chunks = 61